import { PACKAGE_PICKER_EVENTS } from '../types/enums/events';
import { createPubSub } from '../utils';
export const packagePickerPubSub = createPubSub();
//# sourceMappingURL=packagePickerPubSub.js.map